import { createAction, handleActions } from 'redux-actions'

const setAdditionalFilter = createAction('SCREENS/TIMESHEETS/SET_ADDITIONAL_FILTER')
const resetAdditionalFilter = createAction('SCREENS/TIMESHEETS/RESET_ADDITIONAL_FILTER')

const defaultState = {}

const reducer = handleActions(
  {
    [setAdditionalFilter]: (state, action) => ({ ...state, ...action.payload }),
    [resetAdditionalFilter]: () => defaultState,
  },
  defaultState,
)

export { setAdditionalFilter, resetAdditionalFilter, reducer }
